// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"dsboZim","subtitle":"eg6eKI2"};